import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AccountService } from '../../shared/services/account.service';
import { AppService } from "../../shared/services/app.service";
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../shared/services/language.service';
import { DOCUMENT } from '@angular/common';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';
import { ProductsService } from '../../shared/services/products.service';
import { BasketService } from '../../shared/services/basket.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
declare var Swal:any;

@Component({
  selector: 'app-safetybox',
  templateUrl: './safetybox.component.html',
  styleUrls: ['./safetybox.component.scss']
})
export class SafetyboxComponent implements OnInit {

  public slides:any = [
    { name: this.language.translate.instant("M. R. - Groupe Lapeyre"), job: this.language.translate.instant("« L’enjeu d’une formation en réalité virtuelle est de faire vivre les sensations de l’accident via la surprise et le visuel grâce à la re-création de l’environnement de travail, qui est un atout considérable pour l’efficacité de l’immersion. »"), logo:"assets/logos-carousels/lapeyre.png" },
    { name: this.language.translate.instant("P. S. - Groupe Colas"), job: this.language.translate.instant("« La réalité virtuelle permet de vivre des situations à risques, sans danger réel. Elle a l’avantage de nous faire vivre des sensations fortes et de nous faire garder en mémoire cette expérience. De nombreux apprenants réagissent après la formation en utilisant des phrases comme « maintenant, je ferai attention à... », ce qui est un indicateur très important pour nous sur la réelle prise de conscience des risques. »"), logo:"assets/logos-carousels/colas.png" }]

    public prices:any = {}
    public loading = true

  constructor(
      public accountService : AccountService,
      private productService: ProductsService,
      public appService : AppService,
      public router : Router,
      public language : LanguageService,
      public translate: TranslateService,
      public sanitizer:DomSanitizer,
      public basketService : BasketService,
      @Inject(DOCUMENT) public document: Document
  ) { }


public listProducts:any = [];
public ids = [144,84,85,46,99,143];


  ngOnInit() {
      this.refreshPrices()

      if(isBrowser() && $('video') && $('video').length){
          for (let i = 0; i<$('video').length; i++) {
              $('video')[i].muted = true;
              $('video')[i].load();
          }
      }

      this.productService.searchProducts(null, [247], 0, 12)
      .then((resultats)=>{
        this.listProducts = this.productService.setProductsInfos(resultats["datas"],-1,-1);
      })

      return this.basketService.getPrices()
      .then((prices)=>{
          this.prices = prices
          // console.log(prices)
      })


  }


  getCurrentLang(){
      return this.translate.store.currentLang;
  }


  refreshPrices(){
      this.loading = true
      return this.basketService.getPrices()
      .then((prices)=>{
          this.loading = false
          this.prices = prices
      })
  }



  freeAccess(){
      this.router.navigate(this.language.navigateAccordingToLang(['/demo']))
  }

}
